const formatValue = {
  formattedValueWithComma: (value, decimalPlaces) => {
    if (!value) {
      return "";
    }

    let numericValue = value.toString().replace(/[^0-9.]/g, "");
    numericValue = parseFloat(numericValue).toFixed(decimalPlaces || 2);
    let formattedValueWithComma = numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (formattedValueWithComma === "NaN") {
      return "";
    } else {
      return formattedValueWithComma;
    }
  },
  formattedValueWithoutComma: (value, decimalPlaces) => {
    if (!value) {
      return "";
    }

    let numericValue = value.toString().replace(/[^0-9.]/g, "");
    numericValue = parseFloat(numericValue).toFixed(decimalPlaces || 2);

    if (numericValue === "NaN") {
      return "";
    } else {
      return numericValue;
    }
  },
};

export default formatValue;
